import { render, staticRenderFns } from "./SupplierProductDetail.vue?vue&type=template&id=7164f71f&scoped=true"
import script from "./SupplierProductDetail.vue?vue&type=script&lang=ts"
export * from "./SupplierProductDetail.vue?vue&type=script&lang=ts"
import style0 from "./SupplierProductDetail.vue?vue&type=style&index=0&id=7164f71f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7164f71f",
  null
  
)

export default component.exports